import React from 'react'
import {TimePicker} from 'antd'

const TimeInput = () => <TimePicker />
export default TimeInput
